import { requestSupport } from "../utils/request"

export function imageUpload(data) {
    return requestSupport({
        url: "/upload",
        method: "post",
        data
    })
}
